import React, { Component } from 'react'
import Style from './AddOrganization.module.css'
import { setError, setCurrentCustomer, addWhitelistDomain, getWhitelistDomains } from '../store/entities/customers'
import { connect } from 'react-redux'
import ModalPopup from '../components/common/ModalPopup'

import BackIcon from '../assets/backButton.svg'

class AddWhitelistDomain extends Component {

    constructor() {
        super();
        this.state = {
            domain: ''
        };
    }
    componentDidMount() {
        if(this.props.selectedCustomer) {
            this.props.getWhitelistDomains(this.props.selectedCustomer.id)
        }    
    }

    componentDidUpdate(prevProps) {
    }

    handleModalClick = () => {
        this.props.history.push({ pathname: `/customers/${this.props.selectedCustomer.id}/settings`, state: { tab: 'Whitelist Management' } })  
    }

    handleChange = (event) => {
        const value = event.target.value
        this.setState({
            domain: value.trim()
        })
    }

    handleClick = () => {
            this.props.history.push({ pathname: `/customers/${this.props.selectedCustomer.id}/settings`, state: { tab: 'Whitelist Management' } })  
    }

    handleSubmit = () => {
        // let pattern = new RegExp(/^(?!:\/\/)(?!www\.)(?!http:\/\/)(?!.*--)([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/); 
        //  updated pattern 
        let pattern = new RegExp(/^(?!:\/\/)(?!www\.)(?!http:\/\/)(?!.*--)([a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*)(:\d{1,5})?$/);
 
        /*
        1.Alphanumeric Characters and Hyphens:
            The domain name can contain letters (both uppercase and lowercase), numbers, and hyphens.
        2.No "www." at the Beginning:
            The domain name should not start with "www.".
        3.No "http://" at the Beginning:
            The domain name should not start with "http://" or "https://".
        4.At Least One Dot (.) in the Domain:
            There must be at least one dot (.) in the domain name, indicating the separation between the domain and the top-level domain (TLD).
        5.Top-Level Domain (TLD) Requirement:
            The domain should end with a valid top-level domain (e.g., ".com", ".net", ".org").
            The top-level domain must consist of at least two characters.
        6.Consecutive two hyphens are not allowed in domain name. 
        7.Ports should be in the Range: 1–65535
        8.Default ports (e.g.0, ,21, 22, 80, 443, 1023) are not allowed
        */
        
        let error = '';
        if(this.state.domain === '') {
            error = "Domain is required."
            this.props.setError(error)
        }
        else if(this.state.domain.length > 255) {
            error = "Domain name should not exceed 255 characters."
            this.props.setError(error)
        }
        else if(this.isDomainDuplicate(this.state.domain, this.props.whitelistDomains)) {
            error = "Domain already exists in the whitelist."
            this.props.setError(error);
        }
        else if(!pattern.test(this.state.domain)){
            error = "Please enter a valid domain, do not include web protocols like http/https in the domain. Also check if the port number is valid.\n";
            this.props.setError(error)
        }
        else if (!this.isPortValid(this.state.domain)) {
            error = "Please enter a valid port number in the domain.Ports should be in the range 1-65535 and should not include default ports like 0, 21, 22, 80, 443, 1023.\n";
            this.props.setError(error)
        }
        if(error.length === 0) {
            error = '';
            let body = {
                "domain": this.state.domain
            }
            this.props.addWhitelistDomain(this.props.selectedCustomer.id, body)
        }
         
    }

    isDomainDuplicate = (domain, whitelistDomains) => {
        // console.log('whitelistDomains', whitelistDomains)
        // console.log('domain', domain)
        let isDuplicate = false;
        whitelistDomains.forEach((whitelistDomain) => {
            if(whitelistDomain.authorizedDomain.trim() === domain.trim()) {
                isDuplicate = true;
            }
        })
        return isDuplicate;
    }

    isPortValid = (domain) => {
        const reservedPorts = [0, 21, 22, 80, 443, 1023];
        let port = domain.split(":")[1];
        port = port ? parseInt(port) : null;
        if( port !== null) {
            if(port < 1 || port > 65535 ) {
                return false;
            }
            if(reservedPorts.includes(port)) {
                return false;
            }
        }
        return true;
    }

    render() {
        return (
            <div className={'px-5 mt-4'}>
                <div className={`${Style.headerBg} px-5 d-flex align-items-center justify-content-between`}>
                    <div onClick={this.handleClick} style={{ cursor: 'pointer' }}>
                        <img style={{ height: '1.5vw' }} src={BackIcon} alt={'back-icon'} />
                        Return to Allowed Domains
                    </div>
                </div>
                <div className={`${Style.detailsContainer} w-50 mt-4 py-5 px-5`}>
                    <div className={`d-flex flex-column`}>
                        <input name='Domain' placeholder={'Domain'} className={`${Style.inputStyle} focus-none mt-3`} onChange={this.handleChange} />
                    </div>
                    <div className={'mt-4'}>
                        <button onClick={this.handleSubmit} className={`${Style.submitButton} px-4 focus-none`}>Add Domain</button>
                        <button onClick={this.handleClick} className={`${Style.cancelButton} px-4 ml-2 focus-none`}>Cancel</button>
                    </div>
                </div>
                {this.props.statusCode && <ModalPopup handleClick={this.handleModalClick} statusCode={this.props.statusCode} msg={this.props.userMsg}/> }
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    selectedCustomer: state.entities.customers.selected,
    userRole: state.entities.user.roles,
    userMsg: state.entities.customers.userMsg,
    statusCode: state.entities.customers.statusCode,
    whitelistDomains: state.entities.customers.whitelistDomains,

})

const mapDispatchToProps = (dispatch) => ({
    addWhitelistDomain: (customerId, body) => dispatch(addWhitelistDomain(customerId, body)),
    setError: (error) => dispatch(setError(error)),
    getWhitelistDomains: (customerId) => dispatch(getWhitelistDomains(customerId)),
})

export default connect(mapStateToProps, mapDispatchToProps)(AddWhitelistDomain)